import {Typography} from '@mui/material';

export default function LandingProblem() {
  return (
    <>
      <Typography variant="h2" gutterBottom>
        The Problem We&apos;re Solving
      </Typography>
      <Typography variant="body1">
        Managing an Etsy shop is overwhelming—repetitive listing updates, SEO struggles, and time-consuming admin work
        take away from what really matters: your creativity and sales.
      </Typography>
      <Typography variant="body1">
        That&apos;s why we&apos;re developing a powerful yet simple tool to streamline your workflow.
      </Typography>
    </>
  );
}
